//Important:
//The order and roles values must be equal at the backend
//Please refer BD.HSPA.WebApi\BD.HSPA.Data\Enums\HSPARole.cs file
export enum HSPARole {
    None = 0,
    BDSystemAdministrator = 2, //admin value 2
    ClinicianUser = BDSystemAdministrator * 2, // value 4
    CustomerSystemAdministrator = ClinicianUser * 2, // value 8
}
